module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/5b9f8b09139e56f3993609db9e8f57ab.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_learninggaps.svg
// module id = YFtY
// module chunks = 0